module.exports = "<div class='form-sp'>\n  {{ 'createOrgVdc.wizard.storageReserved' | translate }}\n  ({{ 'createOrgVdc.grid.header.gb' | translate }})\n  <clr-icon shape=\"add\" (click)='addComponentNew()' class='action-icon is-success'></clr-icon>\n  <form #sp='ngForm' (ngSubmit)='onSubmit(form-sp)' class='sp-container'>\n    <div #widgetContainer style='width:100%'></div>\n  </form>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/storage-profile/storage-profile-widget.html
// module id = o1pD
// module chunks = 0